// Mock Data for JB's Homoeopathy Platform

export const BRAND = {
  name: "JB's Homoeopathy",
  tagline: "Your Partner for a Healthy You",
  doctorName: "Dr. Jenice Bhatia",
  doctorEmail: "drjenicebhatia@gmail.com",
  doctorPhone: "+91 73531 96539",
  logo: "https://customer-assets.emergentagent.com/job_wellness-appt/artifacts/jfqcynks_Untitled%20design.png",
  // Colors derived from logo
  colors: {
    primary: "#2F5233",       // Deep organic green
    secondary: "#E91E8C",     // Vibrant pink/magenta
    accent: "#F5A623",        // Warm gold/amber
    background: "#FDF9F5"     // Soft beige
  },
  description: "Experience the gentle power of homeopathic healing with personalized care from Dr. Jenice Bhatia. We believe in treating the whole person, not just the symptoms.",
  address: {
    line1: "525, Mall Road",
    line2: "Near Sector 37 Water Tank",
    area: "Sector 29, Noida",
    full: "525, Mall Road, Near Sector 37 Water Tank, Sector 29, Noida",
    mapUrl: "https://www.google.com/maps/place/Dr.+Jenice+Bhatia+Clinic/@28.568629,77.3361576,17z"
  },
  clinics: [
    {
      name: "Sector 29 Clinic",
      full: "525, Mall Road, Near Sector 37 Water Tank, Sector 29, Noida",
      mapUrl: "https://www.google.com/maps/place/Dr.+Jenice+Bhatia+Clinic/@28.568629,77.3361576,17z"
    },
    {
      name: "Sector 116 Clinic",
      full: "H18 (Basement), Community Center Rd, Sector 116, Noida, Uttar Pradesh 201301",
      mapUrl: "https://www.google.com/maps/dir//Dr+Jenice+Bhatia+Homeopathic+Clinic,+H18+(Basement,+Community+Center+Rd,+Sector+116,+Noida,+Uttar+Pradesh+201301/@28.5222018,77.4018255,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390cef25a44351d3:0x13a8bb6d2c258461!2m2!1d77.3989467!2d28.5658982?hl=en-IN&entry=ttu&g_ep=EgoyMDI2MDkwMi4wIKXMDSoASAFQAw%3D%3D"
    }
  ]
};

export const SERVICES = [
  {
    id: 1,
    title: "Online Consultation",
    description: "Connect with Dr. Bhatia from the comfort of your home via secure video consultation.",
    price: 1200,
    currency: "INR",
    duration: "30 minutes",
    icon: "video",
    features: [
      "Secure video call",
      "Digital prescription",
      "Follow-up support",
      "Convenient scheduling"
    ]
  },
  {
    id: 2,
    title: "In-Clinic Consultation",
    description: "Visit our clinic for a comprehensive in-person consultation and examination.",
    price: 1200,
    currency: "INR",
    duration: "30 minutes",
    icon: "building",
    features: [
      "Physical examination",
      "Immediate prescription",
      "Personalized care",
      "Medicine guidance"
    ]
  }
];

export const AVAILABILITY = {
  workingDays: ["Monday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  offDay: "Tuesday",
  weekdaySessions: [
    { start: "11:00", end: "14:00", label: "11:00 AM - 2:00 PM" },
    { start: "16:00", end: "19:00", label: "4:00 PM - 7:00 PM" }
  ],
  weekendSessions: [
    { start: "11:00", end: "15:00", label: "11:00 AM - 3:00 PM" }
  ],
  slotDuration: 30,
  timezone: "Asia/Kolkata"
};

export const generateTimeSlots = (date) => {
  const dayOfWeek = new Date(date).toLocaleDateString('en-US', { weekday: 'long' });
  
  if (dayOfWeek === 'Tuesday') {
    return [];
  }
  
  const slots = [];
  const times = ['11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30'];
  
  times.forEach((time, index) => {
    const isAvailable = Math.random() > 0.3;
    slots.push({
      id: `${date}-${index}`,
      time: time,
      displayTime: formatTime(time),
      available: isAvailable
    });
  });
  
  return slots;
};

const formatTime = (time) => {
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour > 12 ? hour - 12 : hour;
  return `${displayHour}:${minutes} ${ampm}`;
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "Dr. Jenice's treatment completely transformed my health. After years of chronic migraines, I finally found relief through homeopathy.",
    avatar: "PS"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Delhi",
    rating: 5,
    text: "The online consultation was so convenient. Dr. Bhatia took her time to understand my symptoms and provided a comprehensive treatment plan.",
    avatar: "RK"
  },
  {
    id: 3,
    name: "Anita Desai",
    location: "Bangalore",
    rating: 5,
    text: "My daughter's allergies improved significantly within weeks of starting treatment. Highly recommend JB's Homoeopathy!",
    avatar: "AD"
  },
  {
    id: 4,
    name: "Vikram Singh",
    location: "Chennai",
    rating: 5,
    text: "Professional, caring, and truly effective. Dr. Jenice's approach to healing is both scientific and compassionate.",
    avatar: "VS"
  }
];

export const CONDITIONS_TREATED = [
  "Allergies & Respiratory Issues",
  "Skin Disorders",
  "Digestive Problems",
  "Hormonal Imbalances",
  "Anxiety & Stress",
  "Chronic Pain",
  "Pediatric Conditions",
  "Women's Health",
  "Autoimmune Disorders",
  "Sleep Disorders"
];

export const FAQ = [
  {
    question: "What is Homoeopathy?",
    answer: "Homoeopathy is a natural form of medicine that stimulates the body's own healing abilities. It treats each person as a unique individual with the aim of stimulating their own healing ability."
  },
  {
    question: "How long does treatment take?",
    answer: "Treatment duration varies depending on the condition and individual response. Acute conditions may improve within days, while chronic conditions may require several months of treatment."
  },
  {
    question: "Are homoeopathic medicines safe?",
    answer: "Yes, homoeopathic medicines are completely safe and have no known side effects. They can be taken alongside conventional medicines and are safe for all ages, including infants and pregnant women."
  },
  {
    question: "What should I expect during a consultation?",
    answer: "During consultation, Dr. Bhatia will take a detailed case history including your symptoms, medical history, lifestyle, and emotional state to prescribe the most suitable remedy."
  },
  {
    question: "Can I upload my previous medical reports?",
    answer: "Yes, you can upload up to 5 files (PDF, JPG, PNG) up to 10MB each during booking. This helps the doctor understand your condition better."
  }
];

export const APPOINTMENT_STATUSES = {
  REQUESTED: { label: 'Requested', color: 'bg-amber-100 text-amber-800' },
  PENDING: { label: 'Pending Approval', color: 'bg-blue-100 text-blue-800' },
  CONFIRMED: { label: 'Confirmed', color: 'bg-emerald-100 text-emerald-800' },
  RESCHEDULED: { label: 'Rescheduled', color: 'bg-purple-100 text-purple-800' },
  REJECTED: { label: 'Rejected', color: 'bg-red-100 text-red-800' },
  COMPLETED: { label: 'Completed', color: 'bg-gray-100 text-gray-800' },
  CANCELLED: { label: 'Cancelled', color: 'bg-gray-100 text-gray-600' }
};

export const PAYMENT_STATUSES = {
  PENDING: { label: 'Payment Pending', color: 'bg-amber-100 text-amber-800' },
  PAID_ONLINE: { label: 'Paid Online', color: 'bg-emerald-100 text-emerald-800' },
  PAYMENT_PENDING: { label: 'Pay at Clinic', color: 'bg-blue-100 text-blue-800' }
};

export const MOCK_APPOINTMENTS = [
  {
    id: 'APT001',
    patient_name: 'John Doe',
    patient_email: 'john@example.com',
    patient_phone: '+919876543210',
    consultation_type: 'ONLINE',
    appointment_date: '2025-07-18',
    time_slot: '11:00',
    reason: 'Chronic headaches and fatigue',
    status: 'CONFIRMED',
    payment_status: 'PAID_ONLINE',
    amount: 1200,
    created_at: '2025-07-14T10:30:00Z',
    meeting_link: 'https://meet.google.com/abc-defg-hij',
    uploadedReports: [
      {
        fileName: 'blood_test_report.pdf',
        fileType: 'application/pdf',
        fileSize: 1024000,
        uploadedAt: '2025-07-14T10:25:00Z',
        s3Key: 'reports/apt001/blood_test_report.pdf'
      }
    ]
  },
  {
    id: 'APT002',
    patient_name: 'John Doe',
    patient_email: 'john@example.com',
    patient_phone: '+919876543210',
    consultation_type: 'OFFLINE',
    appointment_date: '2025-07-10',
    time_slot: '12:00',
    reason: 'Follow-up for skin condition',
    status: 'COMPLETED',
    payment_status: 'PAID_ONLINE',
    amount: 1200,
    created_at: '2025-07-05T14:20:00Z',
    uploadedReports: []
  }
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1687181082775-32b5a6e69017?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGhlYWxpbmd8ZW58MHx8fHwxNzY4NDMzMjM1fDA&ixlib=rb-4.1.0&q=85',
  homeopathy: 'https://images.unsplash.com/photo-1512867957657-38dbae50a35b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxob21lb3BhdGh5fGVufDB8fHx8MTc2ODQzMzIyM3ww&ixlib=rb-4.1.0&q=85',
  doctor: 'https://images.unsplash.com/photo-1666214277730-e9c7e755e5a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxkb2N0b3IlMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzY4NDMzMjI5fDA&ixlib=rb-4.1.0&q=85',
  consultation: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxkb2N0b3IlMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzY4NDMzMjI5fDA&ixlib=rb-4.1.0&q=85',
  medicine: 'https://images.pexels.com/photos/163186/globuli-medical-bless-you-homeopathy-163186.jpeg',
  wellness: 'https://images.unsplash.com/photo-1619968747465-f56008f0da50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzcyUyMGhlYWxpbmd8ZW58MHx8fHwxNzY4NDMzMjM1fDA&ixlib=rb-4.1.0&q=85'
};
